/**
 * goToChannelsGuide action.
 */
import Event from '../../classes/event';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

/**
 * Function to redirect to the channel guide page.
 */
export default function goToChannelsGuide(asset?: Event | null) {
  const { media } = store.getState();
  if (asset?.channel?.id) {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.CHANNEL_GUIDE },
        params: {
          current: { channelId: asset?.channel?.id },
          push: true,
          stack: { position: !media.live ? media.currentTime : undefined },
        },
      })
    );
  }
}
